export const COMPUTER_TABLE_ACTION = {
  EXPAND: "agent-expand",
  OPEN: "agent-open",
  EDIT: "agent-edit",
  UNINSTALL: "agent-uninstall",
  DELETE: "agent-delete",
  UPDATE: "agent-update",
};

export const COMPUTER_BULK_ACTION = {
  VACCINATE: "vaccinate-computers",
  UNINSTALL: "uninstall-computers",
  DELETE: "delete-computers",
  TAG: "tag-computers",
  UNTAG: "untag-computers",
  MOVE: "move-computers",
};

export const COMPUTER_DEFAULT_SORT = { sortBy: "computerName", orderBy: "asc" };
